import '@hotwired/turbo-rails';
import '../controllers/index';
import KeyGen from '../keygen';
import { Decrypt } from '../decrypt';
import Papa from 'papaparse';
import TomSelect from 'tom-select';

// add new dependencies via npm install <dependency>
// vite will/should load them automagically

// TODO: this stuff is used in non-stimulus javascript code
//       convert everything to stimulus or vue
window.Papa = Papa;
window.TomSelect = TomSelect;

// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>ü
console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails');

// Example: Load Rails libraries in Vite.
//
import * as Turbo from '@hotwired/turbo';
Turbo.start();
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// Import all channels.
const channels = import.meta.glob('../channels/*_channel.*', { eager: true });

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
